import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { Button, Form, Modal } from 'react-bootstrap';
import Select from 'react-select';
import Swal from 'sweetalert2';

import {
  DATA_SOURCE_CLONE,
  GLOBAL_MANUFACTURERS_FOR_DROPDOWN,
  GLOBAL_VENDORS_FOR_DROPDOWN,
} from 'lib/networking/endpoints';
import DATA_SOURCE_ENTITY from 'lib/enums/DataSourceEntity';
import SearchableScrollableSelect from 'components/shared/SearchableScrollableSelect';
import useGet from 'lib/hooks/useGet';
import usePost from 'lib/hooks/usePost';

function CloneDataSourceModel({ onHide, dataSource, refetch }) {
  const [entity, setEntity] = useState();
  const [entityType, setEntityType] = useState();
  const [dataSourceName, setDataSourceName] = useState('');

  const { data: { data: globalVendors } = {} } = useGet(GLOBAL_VENDORS_FOR_DROPDOWN);

  const entityNames = useMemo(() => {
    if (entityType === DATA_SOURCE_ENTITY.VENDOR && globalVendors) {
      return globalVendors.map(vendor => ({
        value: vendor.id,
        label: vendor.name,
      }));
    }
    return [];
  }, [entityType, globalVendors]);

  useEffect(() => {
    if (dataSource.entity_type) {
      setEntityType(dataSource.entity_type);
      setDataSourceName(dataSource.source_name);
    }
  }, [dataSource]);

  const { postData: cloneDataSource, loading: cloneDataSourceLoading } = usePost(
    DATA_SOURCE_CLONE,
    () => {
      Swal.fire({
        icon: 'success',
        text: 'Data source cloned successfully, Please update the name',
        title: 'Success',
        timer: 500,
      }).then(() => {
        refetch();
      });
    },
    error =>
      Swal.fire({
        icon: 'error',
        text: `An error occurred while cloning: ${error?.response?.data?.message}`,
        title: 'Error',
      }),
  );

  return (
    <Modal show={true} onHide={onHide} size="lg" className="px-6" centered animation={false}>
      <Modal.Header>
        <div className="d-flex flex-column">
          <Modal.Title className="mont">
            <h2 className="bold">Select Entity name if it exists for this data source</h2>
          </Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>Name</Form.Label>
          <Form.Control
            type="text"
            value={dataSourceName}
            onChange={e => setDataSourceName(e.target.value)}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>Entity Name</Form.Label>
          {entityType === DATA_SOURCE_ENTITY.MANUFACTURER ? (
            <SearchableScrollableSelect
              onChange={option => setEntity(option)}
              fetchUrl={GLOBAL_MANUFACTURERS_FOR_DROPDOWN}
              optionMapper={manufacturer => ({
                label: manufacturer.name,
                value: manufacturer.id,
              })}
              autoFocus={false}
              placeholder="Select Manufacturer"
            />
          ) : (
            <Select
              value={entity}
              options={entityNames}
              onChange={e => setEntity(e)}
              isSearchable
              isClearable
            />
          )}
        </Form.Group>
        <Button
          onClick={() => {
            cloneDataSource({
              data_source_id_to_clone: dataSource.id,
              entity_id: entity.value || null,
              data_source_name: dataSourceName,
            });
            onHide();
          }}
        >
          Save
        </Button>
      </Modal.Body>
    </Modal>
  );
}

CloneDataSourceModel.propTypes = {
  onHide: PropTypes.func,
  dataSource: PropTypes.object,
  refetch: PropTypes.func,
};

export default CloneDataSourceModel;
